import React from 'react';
import DownloadManual from './DownloadManual';
import Button from '../DMGComponents/Button';
import { pca, getDMGUser } from '../authProvider';

class AuthenticatedHeader extends React.Component {
    render() {
        return (
            <div style={{ display: "flow-root" }}>
                <DownloadManual />
                <div id="logOut" style={{ display: "flex", float: "right", alignItems: "center" }}>
                    <div style={{ marginRight: "-42px" }}>{getDMGUser()}</div>
                    <div className="logOutBtnWrap">
                        <div className="logOutBtnContent">
                            <Button type="hover-bottom-left" onClick={() => { pca.logoutRedirect() }}>Log Out</Button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default AuthenticatedHeader;